<template>
  <div class="page-content">
    <card-container
      :id="pageId"
      :is-loading="isLoading"
      button-location="top"
    >
      <template #title>
        Membership Pricing
      </template>

      <template #top-form>
        <div class="row justify-content-center">
          <el-radio-group v-model="planCurrency">
            <el-radio-button label="USD" />
            <el-radio-button label="CAD" />
            <el-radio-button label="AUD" />
          </el-radio-group>
        </div>
      </template>

      <template #content>
        <PricePlanning
          hideSelectPackage
        />
      </template>
    </card-container>
  </div>
</template>

<script setup lang="ts">
import { ref, defineAsyncComponent } from 'vue';

import { getPlanPricing, planCurrency, planPricing } from '@/services/pricing';
import { useCustomer } from '@/use/customer'

const PricePlanning = defineAsyncComponent(() => import('@/components/UIComponents/PricePlanning.vue') as any);

const pageId = 'membership-price-planning';

const isLoading = ref(false);

const { customerInfo, newCustomerInfo } = useCustomer();

const getLoadPlanPricing = async () => {
  if (customerInfo.value?.id || newCustomerInfo.value?.id) {
    // planPricing should already be loaded
    return;
  }

  try {
    isLoading.value = true;
    planPricing.value = await getPlanPricing().catch(err => []);
  } finally {
    isLoading.value = false;
  }
};

getLoadPlanPricing();
</script>
